import { KeyValueDescriptionType, KeyValueType } from '@models/common';
import { GlobalFilterKeys } from '@models/module/fields/enums';
import { DataListAggregateFormulaFieldModel, DataListComplexFormulaFieldModel, DataListType } from '@models/module/fields/main';
import { DataListFields } from '@models/module/main/dataListFields';
import { ScreenTypeEnum } from '@module-definition/screen/common';

export interface GridFieldsModel {
  userIsInitiator: boolean;
  hasStartScreenFields: boolean;
  hasPresets: boolean;
  information: string;
  canPrint: boolean;
  topFormulas: DataListComplexFormulaFieldModel[];
  bottomFormulas: DataListAggregateFormulaFieldModel[];
  fields: DataListFields[];
  isContractClosedOrArchived: boolean;
  globalFilters: KeyValueType<GlobalFilterKeys>[];
  startScreens: KeyValueDescriptionType<number>[];
  otherScreens: OtherScreenModel[];
  defaultDataListType: DataListType;
}

export type OtherScreenModel = {
  displayTypeId: number;
  key: number;
  typeId: ScreenTypeEnum;
  value: string;
};

export interface GridFieldsSOVModel extends GridFieldsModel {
  hasExistingWBS: boolean;
  categoryGroups: KeyValueType<number>[];
  soviScreens: KeyValueType<number>[];
}
